import axios from 'axios';
import {Component} from 'react';
import AdminNotes from 'components/admin/AdminNotes';
import AdminNotesFilter from 'components/admin/AdminNotesFilter';
import connected from 'connected';

export class AdminNotesPage extends Component {
  state = {
    notes: [],
  };

  onSubmit = async (payload) => {
    const response = await axios.post('/api/admin/notes', payload);
    this.setState({notes: response.data});
  };

  render() {
    const {notes} = this.state;
    return (
	<div className="admin-notes-page">
	  <AdminNotesFilter onSubmit={this.onSubmit}/>
	  <AdminNotes notes={notes}/>
	</div>
      );
  }
}

export default connected(AdminNotesPage);
